const styles = theme => ({
  root: {
    width: '100%',
    padding: '0 80px',
    [theme.breakpoints.down('lg')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 24px',
    },
    transition: 'padding 0.3s ease-in-out',
  },
  contentWrapper: {
    maxWidth: '1280px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    [theme.breakpoints.down('sm')]: {
      gap: '24px',
    },
  },
  content: {
    display: 'flex',
    gap: '32px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '24px',
    },
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      gap: '24px',
    },
  },
  greeting: {
    fontSize: '24px',
    fontWeight: 600,
    marginTop: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',

    [theme.breakpoints.down('sm')]: {
      gap: '16px',
    },
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
    },
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  allLink: {
    color: '#002E47',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    padding: '48px',
    textAlign: 'center',
    borderRadius: '16px',
    height: '320px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      padding: '24px',
      gap: '16px',
    },
  },
  emptyStateText: {
    fontSize: '24px',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  blueText: {
    color: '#015ffb',
  },
  coursesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '24px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '16px',
    },
  },
  collectionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '24px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: '16px',
    },
  },
})

export default styles
